import React from 'react';
import './PeriodToggle.css';

export type ReportingPeriod = 'weekly' | '4weekly';

interface PeriodToggleProps {
  currentPeriod: ReportingPeriod;
  onPeriodChange: (period: ReportingPeriod) => void;
  disabled?: boolean;
}

const PeriodToggle: React.FC<PeriodToggleProps> = ({ 
  currentPeriod, 
  onPeriodChange, 
  disabled = false 
}) => {
  const handleToggleClick = (period: ReportingPeriod) => {
    if (!disabled && period !== currentPeriod) {
      console.log('📊 [PERIOD-TOGGLE] Switching to:', period);
      onPeriodChange(period);
    }
  };

  return (
    <div className={`period-toggle ${disabled ? 'disabled' : ''}`}>
      <div className="period-toggle-label">Report Period:</div>
      <div className="period-toggle-buttons">
        <button
          type="button"
          className={`period-button ${currentPeriod === 'weekly' ? 'active' : ''}`}
          onClick={() => handleToggleClick('weekly')}
          disabled={disabled}
          title="View weekly report (7 days)"
        >
          Weekly
        </button>
        <button
          type="button"
          className={`period-button ${currentPeriod === '4weekly' ? 'active' : ''}`}
          onClick={() => handleToggleClick('4weekly')}
          disabled={disabled}
          title="View 4-weekly report (4 weeks / 28 days)"
        >
          4 Weekly
        </button>
      </div>
    </div>
  );
};

export default PeriodToggle;